<template>
  <div class="cm-box-container" :style="{ width: this.width}">
      <div :style="{background: headerColor}" :class="['cm-box-container-header', {smaller: small}]">
        <div style="display: flex; align-items: center">
          <v-icon v-if="icon" color="white" style="margin-right: 10px">{{icon}}</v-icon>
          <h1 style="padding: 0; margin: 0">{{title}}</h1>
        </div>
        <v-icon v-if="showClose" :large="!small" color="red" @click="$emit('close')">mdi-close</v-icon>
      </div>

      <div :class="['cm-box-container-content', {smaller: small}]">
        <slot />
      </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => 'Box header'
    },
    showClose: {
      type: Boolean,
      default: () => false
    },
    width: {
      type: String,
      default: () => "100%"
    },
    small: {
      type: Boolean,
      default: () => false
    },
    headerColor: {
      type: String,
      default: () => '#24AB80'
    },
    icon: {
      type: [Boolean, String],
      default: () => false
    }
  }
}
</script>

<style lang="scss" scoped>
.cm-box-container {
  background: white;
  box-shadow: 3px 3px 3px rgba(0,0,0,0.2);

  .cm-box-container-header {
  padding: 10px 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

    h1 {
      margin: 0;
      font-size: 18px !important;
      color: white;
    }

    &.smaller {
      padding: 10px 10px 10px 10px;

      h1 {
        font-size: 16px !important;
      }
    }
  }

  .cm-box-container-content {
    padding: 10px 20px;

    &.smaller {
      padding: 0;
    }
  }
}
</style>
    
    